import React from 'react';

import { UserAvatar } from './Avatar';

import { IconButton, ListItem, ListItemAvatar, ListItemText, makeStyles } from '@material-ui/core';
import { Delete } from '@material-ui/icons';

const useStyles = makeStyles((theme)=>({
    Text : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        backgroundColor : 'black',
        color: '#e5e7eb',
    },
    secondary : {
        color: '#e5e7eb',
        fontSize: '0.75rem !important' ,
    },
    delete : {
        borderRadius: 'none',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'black',
            color : 'red',
            border : 'none',
            borderRadius : '50%',
        },
    }
}));

const ReceiverListItem = function ReceiverListItem({ status, receiver, handleRemove }){

    const classes = useStyles();

    return(
        <ListItem key={receiver._peerid} >
            <ListItemAvatar>
                <UserAvatar userName={receiver.nickname} />
            </ListItemAvatar>
            <ListItemText classes={{ primary : classes.Text, secondary : classes.secondary }} primary={receiver.nickname.length > 15 ? receiver.nickname.slice(0,8) + '...' + receiver.nickname.slice(receiver.nickname.length - 4,) : receiver.nickname } secondary={status} />
            <IconButton onClick={()=>{ handleRemove(receiver) }} classes={{ root : classes.delete }} >
                <Delete />
            </IconButton>
        </ListItem>
    )

}

export default ReceiverListItem;